module.exports = __webpack_public_path__ + "img/Villa_Borna_30.a0308406.jpg";